import apiService from '@/member/services/apiService'
import VueCookie from 'vue-cookies'
import i18n from '@/member/langs/lang'

const authToken = () => {
  return VueCookie.get('auth_token')
}

const isVerifyCode = () => {
  return VueCookie.get('is_verify_code') === 'true'
}

const expireAt = () => {
  return window.localStorage.getItem('expire_at')
}

const isGeneralDivision = () => {
  return window.localStorage.getItem('is_general_division')
}
const organizationId = () => {
  return VueCookie.get('organization_id')
}
const roleId = () => {
  return VueCookie.get('role_id')
}

const getDefaultState = () => {
  return {
    authToken: authToken() || '',
    isVerifyCode: isVerifyCode() || false,
    expireAt: expireAt(),
    isGeneralDivision: isGeneralDivision() || false,
    organizationId: organizationId() || '',
    roleId: roleId() || '',
  }
}

const state = getDefaultState()

const mutations = {
  SET_TOKEN(state, payload) {
    // set token
    state.authToken = payload.auth_token
    VueCookie.set('auth_token', payload.auth_token)
    // set expire at
    state.expireAt = payload.expire_at
    window.localStorage.setItem('expire_at', payload.expires_at)
  },
  SET_IS_VERIFY_CODE(state, payload) {
    state.isVerifyCode = payload
  },
  RESET_TOKEN(state) {
    // reset token
    state.authToken = ''
    VueCookie.remove('auth_token')
    // 団体IDのリセット
    state.organizationId = ''
    VueCookie.remove('organization_id')
    // role_idのリセット
    state.roleId = ''
    VueCookie.remove('role_id')
    // reset expire at
    state.expireAt = null
    window.localStorage.removeItem('expire_at')
  },
  RESET_CODE(state) {
    state.isVerifyCode = false
    VueCookie.remove('is_verify_code')
  },
  SET_IS_GENERAL_DIVISION(state, payload) {
    state.isGeneralDivision = payload
    window.localStorage.setItem('is_general_division', payload)
  },
  SET_ORGANIZATION_ID(state, payload) {
    state.organizationId = payload.organization_id
    VueCookie.set('organization_id', payload.organization_id)
  },
  SET_ROLE_ID(state, payload) {
    state.roleId = payload.role_id
    VueCookie.set('role_id', payload.role_id)
  },
}

const actions = {
  async verifyTfaToken({ commit }, payload) {
    const apiResult = await apiService.post(payload.url || payload.name, payload.params || {})
    commit('SET_IS_VERIFY_CODE', apiResult.success)
    VueCookie.set('is_verify_code', apiResult.success)
    const data = apiResult.data
    if (data.is_general_affair_division) {
      commit('SET_IS_GENERAL_DIVISION', data.is_general_affair_division)
    }

    return apiResult
  },
  async login({ commit }, payload) {
    const isCheckAuth = false
    const isRefresh = true
    const apiResult = await apiService.post(payload.url || payload.name, payload.params || {}, isCheckAuth, isRefresh)
    if (apiResult.success && apiResult.data && apiResult.data.auth_token) {
      commit('SET_TOKEN', apiResult.data)
      commit('SET_ORGANIZATION_ID', apiResult.data)
      commit('SET_ROLE_ID', apiResult.data)
    }

    return apiResult
  },
  async refreshToken({ commit }, payload) {
    const isCheckAuth = false
    const isRefresh = true
    const apiResult = await apiService.get(payload.url || payload.name, payload.params || {}, isCheckAuth, isRefresh)
    if (apiResult.success && apiResult.data && apiResult.data.auth_token) {
      commit('SET_TOKEN', apiResult.data)
    }

    return apiResult
  },
  async logout({ commit }, payload) {
    const apiResult = await apiService.post(payload.url || payload.name, payload.params || {})
    if (apiResult.success) {
      commit('RESET_TOKEN')
      commit('RESET_CODE')
      window.localStorage.removeItem('is_remind_token_expire')
      window.localStorage.removeItem('impersonated_division_id')
      window.localStorage.removeItem('is_general_division')
    }
    return apiResult
  },
  // 他部署へのなりすまし
  async impersonate({ commit }, payload) {
    localStorage.setItem('impersonated_division_id', payload.id)

    // DBになりすましを記録
    const apiResult = await apiService.post(route('member.auth.impersonate.login', payload), {}, true)

    return !!apiResult.success
  },
  async deleteImpersonate({ commit }, payload) {
    const apiResult = await apiService.post(route('member.auth.impersonate.delete'), payload)

    return !!apiResult.success
  },
  async changeToken({ commit }, payload) {
    await apiService.refresh(payload.token)
  },
}

export default {
  state,
  mutations,
  actions,
}
